{
  "zh-CN": {
    "chart": {
      "labels": {
        "view": {
          "one": "%{label}:<br><b>%{count}</b> 浏览",
          "other": "%{label}:<br><b>%{count}</b> 浏览"
        },
        "pledgePrice": "%{label}:<br><b>%{count}</b> USD",
        "ingamePrice": "%{label}:<br><b>%{count} %</b>",
        "wishToOwnRatio": "%{label}:<br>每 100 艘拥有对应的期待数: <b>%{count}</b>",
        "patchChange": {
          "one": "%{label}:<br><b>%{count}</b> 处改动",
          "other": "%{label}:<br><b>%{count}</b> 处改动"
        },
        "ship": {
          "one": "%{label}:<br><b>%{count}</b> 飞船",
          "other": "%{label}:<br><b>%{count}</b> 飞船"
        },
        "ship-pie": {
          "one": "%{label}:<br><b>%{count}</b> 飞船 (%{percentage} %)",
          "other": "%{label}:<br><b>%{count}</b> 飞船 (%{percentage} %)"
        },
        "component-pie": {
          "one": "%{label}:<br><b>%{count}</b> 组件 (%{percentage} %)",
          "other": "%{label}:<br><b>%{count}</b> 组件 (%{percentage} %)"
        },
        "user": {
          "one": "%{label}:<br><b>%{count}</b> 用户",
          "other": "%{label}:<br><b>%{count}</b> 用户"
        },
        "user-pie": {
          "one": "%{label}:<br><b>%{count}</b> User (%{percentage} %)",
          "other": "%{label}:<br><b>%{count}</b> Users (%{percentage} %)"
        },
        "visit": {
          "one": "%{label}:<br><b>%{count}</b> 访问",
          "other": "%{label}:<br><b>%{count}</b> 访问"
        },
        "supporterContribution": {
          "amount": "捐助: <b>%{amount}</b>",
          "goal": "目标: <b>%{amount}</b>",
          "count": {
            "one": "<b>%{count}</b> 位支持者",
            "other": "<b>%{count}</b> 位支持者"
          }
        }
      },
      "states": {
        "empty": "暂无可绘制的数据",
        "failed": "无法加载此图表",
        "retry": "重试"
      }
    }
  }
}
